export class ListInitiatorsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "initiators",
            "baseName": "initiators",
            "type": "Array<InitiatorIdentity>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInitiatorsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
